import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';

export interface CurrentMatterByAustralianStateData {
    statistics: Statistics;
}

export interface Statistics {
    matter: Matter;
}

export interface Matter {
    currentMattersByAustralianState: CurrentMattersByAustralianState;
}

export interface CurrentMattersByAustralianState {
    matterStates:             MatterState[];
    currentMattersCount:      number;
    deadMattersCount:         number;
    totalMattersCount:        number;
    totalMattersWithoutState: number;
}

export interface MatterState {
    state:     string;
    stateType: StateType[];
}

export interface StateType {
    description: string;
    count:       number;
}

export interface CurrentMatterByAustralianStateParams {
    entityType?: number;
    entityGuid?: string;
    responsibility?: number;
    showAllRecords?: boolean;
    filter?: string;
}

const CurrentMatterByAustralianStateQuery = gql`
	query mattersByAustralianStateData($entityType: Int, $entityGuid: String, $responsibility: Int, $showAllRecords: Boolean, $filter: String) {
		statistics {
			matter {
				currentMattersByAustralianState(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility, showAllRecords: $showAllRecords, filter: $filter) {
					matterStates {
						state
						stateType {
							description
							count
						}
					}
					currentMattersCount
					deadMattersCount
					totalMattersCount
					totalMattersWithoutState
				}
			}
		}
	}
`;

export const useMatterByAustralianStateQuery = (params: CurrentMatterByAustralianStateParams) => {
    const { data, error, loading } = useQuery<CurrentMatterByAustralianStateData, CurrentMatterByAustralianStateParams>(CurrentMatterByAustralianStateQuery, {
        fetchPolicy: 'network-only',
        variables: {
            entityGuid: params.entityGuid,
            entityType: params.entityType,
            responsibility: params.responsibility,
            showAllRecords: params.showAllRecords,
            filter: params.filter
        },
    });

    return {
        data,
        error,
        loading,
    };
};
